import { useCallback, useEffect, useRef, useState } from "react";

// Fermeture animée : `close()` ajoute la classe « is-closing » pendant `ms`, puis
// appelle `onClose` (la fenêtre disparaît une fois l'animation de sortie finie).
export default function useClosing(onClose, ms = 170) {
  const [closing, setClosing] = useState(false);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const close = useCallback(() => {
    if (timer.current) return;
    setClosing(true);
    timer.current = setTimeout(() => { timer.current = null; setClosing(false); onClose(); }, ms);
  }, [onClose, ms]);
  return [closing, close];
}
